import { Component, OnInit } from '@angular/core';
import { SubscriptionForRegister } from '../_models/SubscriptionForRegister';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AdminServiceService } from '../_services/AdminService.service';
import { ActivatedRoute } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { AuthServiceService } from '../_services/AuthService.service';

@Component({
  selector: 'app-reviewsapi',
  templateUrl: './reviewsapi.component.html',
  styleUrls: ['./reviewsapi.component.css']
})
export class ReviewsapiComponent implements OnInit {

  apiInfo: any;
  projects: any = new Array<any>();
  currentSubscription: SubscriptionForRegister = new SubscriptionForRegister();
  currentApiKey: any;
  jwtHelper = new JwtHelperService();
  decodedToken: any;
  
  constructor(private _adminService: AdminServiceService, private _route: ActivatedRoute, 
    private _alertify: AlertifyService, private _authService: AuthServiceService) { }

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.loadApiInfo(params["id"]);
    });    
  
    this.loadProjects();
  }

  private loadApiInfo(apiId) {
    this._adminService.getApiDetails(apiId).subscribe(details => {
      this.apiInfo = details;
    }, error => {
      this._alertify.error(error);
    });
  }

  onAddNewProject() {
    this.projects.push(new SubscriptionForRegister());
    console.log('adding new project...', this.projects);
  }
  
  loadProjects() {
    this._adminService.getReviewsSubscriptionsByUserId(this._authService.decodedToken.nameid).subscribe(data => {
      console.log('apis loaded', data);
      this.projects = data;
    });
  }
  
  
}
